/*
 * @Author: lsq
 * @Date: 2024-03-12 11:27:50
 * @LastEditTime: 2025-08-28 09:12:38
 * @LastEditors: lsq
 * @Description: 
 * @FilePath: /sunpay-web/src/main.js
 */

import { createApp } from "vue"
import App from "./App.vue"
import print from "vue3-print-nb"
import router from "./router"
import store from "./store"
import fetch from "./service/fetch"
import { filters } from "./service"

import "element-plus/theme-chalk/index.css"
import "@/assets/less/main.less"
// import "@/assets/iconfont/iconfont.css"
// import "@/assets/iconfont/iconfont.js"
// import "@/assets/font/font.css"

import ElementPlus from "element-plus"
import zhCn from "element-plus/dist/locale/zh-cn.mjs"
import components from "@/components/common/index"
import message_box from "@/components/common/MessageBox.js"
import "dayjs/locale/zh-cn"
import { routes } from "./router"

const app = createApp(App)

// 自定义公用组件导入
components.results.forEach(item => {
  const componentConfig = components.requireComponent(item)
  let name = ""
  if (item.match(/\//gi)?.length > 1) {
    if (/(index.vue)$/.test(item)) {
      let dirs = item.split("/")
      name = dirs[dirs.length - 2]
    }
  } else {
    let dirs = item.split("/")
    name = dirs[dirs.length - 1].split(".")[0]
  }
  if (name) {
    app.component(`Tm${name}`, componentConfig.default || componentConfig)
  }
})

app.provide("$fetch", fetch)
app.provide("$filters", filters)
app.provide("$tm_message_box", message_box)
app.provide("$store", store)
app
  .use(router)
  .use(store)
  .use(ElementPlus, {
    locale: zhCn,
  })
  .use(print)
  .mount("#app")

const white_route_list = ["403", "404", 'Link', 'LinkResult']
router.beforeEach((to, from, next) => {
  const user = store.state.user
  const firstMenuPath = store.state.firstMenuPath
  console.log(to.path, to, white_route_list.includes(to.name))
  if (to.path === "/login" || white_route_list.includes(to.name)) {
    next()
  } else if (!user) {
    store.dispatch("GetUserInfo").then(() => {
      next({ ...to })
    }).catch(() => {
      next({ name: "Login", replace: true })
    })
  } else if (!firstMenuPath) {
    // 已登录但权限菜单尚未初始化（持久化丢失或首次），先拉权限再放行
    store.dispatch("GetUserAuthor").then(() => {
      next({ ...to })
    }).catch(() => {
      next()
    })
  } else {
    next()
  }
})

/* 路由异常错误处理，尝试解析一个异步组件时发生错误，重新渲染目标页面 */
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  console.log(targetPath)
  if (isChunkLoadFailed) {
    router.replace(targetPath);
  }
});
